import React, { useEffect, useState } from 'react';
import { Routes,Route, useNavigate } from 'react-router-dom';

import MobileOTP from './folder/screens/auth/Mobile';
import ForgotPassword from './folder/screens/auth/ForgotPassword';
import UpdatePassword from './folder/screens/auth/UpdatePassword';
import './App.css';

import Login from './folder/screens/auth/Login';
import TeacherLogin from './folder/screens/auth/TeacherLogin';
import DistributorLogin from './folder/screens/auth/DistributorLogin';
import { routes } from './folder/components/routes/router';

import toast, { Toaster } from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { FaRegUserCircle } from "react-icons/fa";
import {AiOutlineSetting} from 'react-icons/ai';
import {FiUser} from 'react-icons/fi';
import {MdOutlineSpaceDashboard} from 'react-icons/md';
import {MdOutlineCalendarMonth} from 'react-icons/md';
import {MdOutlineToday} from 'react-icons/md';
import {HiLogout} from 'react-icons/hi';
import {HiOutlineMenuAlt4} from 'react-icons/hi';
import { LogOutAction, NotificationCountAction } from './folder/redux/actions/authAction';
import { Drawer, Modal } from 'antd';
import logo from '../src/folder/images/app_logo.png'
import logo1 from '../src/folder/images/app_logo1.png'
import Splash from './folder/screens/Splash';
import { IoMdClose } from "react-icons/io";
import { TbTruck } from "react-icons/tb";
import { MdOutlineDoorBack } from "react-icons/md";
import PrivateRoute from './folder/components/routes/PrivateRoute';
import PrivacyPolicy from './folder/screens/staticscreens/PrivacyPolicy';
import { disconnectSocket, getSocket } from './folder/screens/socket';
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from './folder/components/button';
import { TbPigMoney } from "react-icons/tb";
import { brandName } from './folder/constants/themeConstants';
import { AiOutlineSchedule } from "react-icons/ai";
import { LuGroup } from "react-icons/lu";
import { MdOutlineAccountBox } from "react-icons/md";
import { MdCardMembership } from "react-icons/md";
import { TbFileInvoice } from "react-icons/tb";
import { MdOutlineLeaderboard, MdOutlineRateReview } from "react-icons/md";

function App() {

  const [step,setstep] = useState(1)
  const [loader,setloader] = useState(true)

  const location = useLocation()
  const {pathname} = useLocation()
  const auth = useSelector(state=>state.Auth)
  const [modal,setmodal] = useState(false)
  const [messageData,setmessageData] = useState({})
  const [drawer_menu,setdrawer_menu] = useState(false)
  const dispatch = useDispatch()

  const path = pathname.split('/')[1]
  
  useEffect(()=>{
     setTimeout(() => {
       setloader(false)
     }, 2500);
  },[])

  useEffect(() => {
      if (auth?.id) {
        const socket = getSocket(auth.id);
  
        socket.on("connect", () => {
          console.log("✅ Connected to socket in dashboard:", socket.id);
        });
  
        socket.on("receive_message", (data) => {
          console.log("data",data)
          toast.success(data?.message)
          dispatch(NotificationCountAction(data?.notification))
          // setmodal(true)
          setmessageData(data)
          // optionally dispatch or show toast/notification
        });

         socket.on("receive_message_call", (data) => {
          toast.success(data?.message)
          dispatch(NotificationCountAction(data?.notification))
          // setmodal(true)
          // setmessageData(data)
          // optionally dispatch or show toast/notification
        });
  
        return () => {
          disconnectSocket();
        };
      }
    }, [auth?.id]);

  const navigate = useNavigate()

  const [mobileOpen, setMobileOpen] = useState(false);

  const disabled_drawer = ['/','/login','/teacher_login','/distributor_login','/forgot_password','/update_password','/password_reset','/privacy',]
  const isPublicFeedbackPage = pathname.startsWith('/parent_feedback')

  // 'bd_user','manager','hod','admin'
  const userRoute = [
    { name: "Dashboard", to: "/dashboard", icon: MdOutlineSpaceDashboard ,size:18,roles:[]},
    { name: "Digital Card", to: "/digital_card", icon: MdCardMembership ,size:18,roles:['admin','Distributor']},
    { name: "Clients", to: "/clients", icon: FaRegUserCircle ,size:18,roles:['executive_team','admin','wfh','Counsellor']},
    { name: "Offline Student", to: "/offline_student", icon: MdOutlineAccountBox ,size:18,roles:['admin']},
    { name: "Invoice", to: "/invoice", icon: TbFileInvoice ,size:18,roles:['admin']},
    { name: "Class Booking", to: "/class_booking", icon: AiOutlineSchedule ,size:18,roles:['Counsellor','admin']},
    { name: "Batch Booking", to: "/batches_booking", icon: LuGroup ,size:18,roles:['Batch','admin']},
    { name: "Today Class", to: "/today_time_table", icon: MdOutlineToday ,size:18,roles:['Batch','admin']},
    { name: "My Time Table", to: "/my_time_table", icon: MdOutlineCalendarMonth ,size:18,roles:['admin']},
    // { name: "Visitor", to: "/visitor", icon: MdOutlineDoorBack, size: 19, roles: ['admin', 'visitor_user','visitor_creator','visitor_admin'] },
    // { name: "Vehicle", to: "/vehicle", icon: TbTruck, size: 19, roles: ['vehicle_creator','admin', 'vehicle_approver','vehicle_admin'] },
    { name: "Profile", to: "/profile", icon: FiUser,size:19,roles:[]},
    { name: "WithDraw", to: "/withdraw", icon: TbPigMoney,size:19,roles:['wfh','admin']},
    { name: "Leaderboard", to: "/teacher_feedback_leaderboard", icon: MdOutlineLeaderboard,size:18,roles:['Teacher','admin']},
    // { name: "Parent Feedback", to: "/settings/parent_feedback", icon: MdOutlineRateReview,size:18,roles:['admin']},

    { name: "Settings", to: "/settings", icon: AiOutlineSetting,size:16,roles:['admin']},
  ];
  // 'admin','controller'

 

  function gotodashboard(){
    navigate('/dashboard/my_dashboard')
  }

 

  const handleLogout = () => {
    dispatch(LogOutAction())
    navigate("/",{ replace: true });
  };

  function handleModalClickFunc(){
    if(location.pathname === '/dashboard/notification'){
        window.location.reload()    
    }
    setmodal(false);
    navigate('/dashboard/notification')
  }

 



  const drawer = (
    <div className={`relative bg-[#2a297e] min-h-screen `}>
      <div className='grid group place-items-center border-b  border-slate-400 py-3'>
      <img onClick={gotodashboard} className='w-[30px] h-[30px] z-40 object-contain mix-blend-screen flex items-center' src={logo1} />
      </div>
      {userRoute?.map((item) => (
        <>
        {item.roles.length > 0 && item?.roles?.filter((e) => auth?.roles?.includes(e))?.length > 0 ?
         <React.Fragment key={item?.to}>
            <div key={item?.name}>
              <div className={`grid py-1.5 place-items-center  text-black  mb-1 cursor-pointer ${path === item?.to?.split('/')[1] ? 'opacity-100 text-black bg-[#de9f19] ' : 'text-white opacity-70'}  ${path === item?.to?.split('/')[1] && 'opacity-100'} `} onClick={()=>{navigate(item.to);setMobileOpen(false)}}>
                {item.icon && <item.icon size={item.size}  /> }
                <span className="mt-1 text-[8px] font-[600]">
                  {item.name} 
                </span>
              </div>
            </div>  
          </React.Fragment>   
          :
          <>
          {item.roles.length === 0 &&
          <React.Fragment key={item?.to}>
            <div key={item?.name}>
              <div className={`grid py-1.5 place-items-center  text-black  mb-1 cursor-pointer ${path === item?.to?.split('/')[1] ? 'opacity-100 text-black bg-[#de9f19] ' : 'text-white opacity-70'}  ${path === item?.to?.split('/')[1] && 'opacity-100'} `} onClick={()=>{navigate(item.to);setMobileOpen(false)}}>
                {item.icon && <item.icon size={item.size}  /> }
                <span className="mt-1 text-[8px] font-[600]">
                  {item.name} 
                </span>
              </div>
            </div>  
          </React.Fragment>}
          </>
          }</>

      ))}

      <div className="grid  bottom-0 py-2 border-white place-items-center opacity-70 hover:opacity-100 text-white  mb-1 cursor-pointer " onClick={handleLogout}>
          <HiLogout size={14}  /> 
          <span className="mt-1 text-[9px] font-[600]">
            {'Log out'}
          </span>
      </div>       
    </div>
  );


  return (
    <div className=' md:w-screen md:overflow-x-hidden'>

      <Modal open={modal} closable={false} footer={false} width={350}>

        <div>
          <h6 className='text-[14px] font-[800] mb-1'>Oops New Message Recived</h6>
          <div className='bg-yellow-100 p-2 '>
            <h6>Message:</h6>
            <h6>{messageData?.message}</h6>
          </div>


          {messageData?.customerInfo?.source === 'meta' &&
          <div className='mt-4 border p-2 border-slate-200'>
          <h6 className='text-[13px] font-[700]'>Meta Info</h6>

          <div className='border mt-2'>

            <div className='flex items-center border-b'>
              <h6 className='bg-blue-500 p-1 text-[12px] min-w-[40%] max-w-[40%] font-[700]'>Type</h6>
              <h6 className='text-[12px] pl-2'>{messageData?.customerInfo?.campaign_info?.name}</h6>
            </div>
            <div className='flex items-center border-b'>
              <h6 className='bg-blue-500 p-1 text-[12px] min-w-[40%] max-w-[40%] font-[700]'>Study Medium</h6>
              <h6 className='text-[12px] pl-2'>{messageData?.customerInfo?.campaign_info?.medium_of_study}</h6>
            </div>
            <div className='flex items-center border-b'>
              <h6 className='bg-blue-500 p-1 text-[12px] min-w-[40%] max-w-[40%] font-[700]'>Name</h6>
              <h6 className='text-[12px] pl-2'>{messageData?.customerInfo?.campaign_info?.student_name}</h6>
            </div>
            <div className='flex items-center border-b'>
              <h6 className='bg-blue-500 p-1 text-[12px] min-w-[40%] max-w-[40%] font-[700]'>Enter Class</h6>
              <h6 className='text-[12px] pl-2'>{messageData?.customerInfo?.campaign_info?.enter_class}</h6>
            </div>
            <div className='flex items-center border-b'>
              <h6 className='bg-blue-500 p-1 text-[12px] min-w-[40%] max-w-[40%] font-[700]'>City of Karnataka Belong To</h6>
              <h6 className='text-[12px] pl-2'>{messageData?.customerInfo?.campaign_info?.which_city_of_karnataka_do_you_belong_to}</h6>
            </div>
            <div className='flex items-center border-b'>
              <h6 className='bg-blue-500 p-1 text-[12px] min-w-[40%] max-w-[40%] font-[700]'>Full Name</h6>
              <h6 className='text-[12px] pl-2'>{messageData?.customerInfo?.campaign_info?.full_name}</h6>
            </div>
             <div className='flex items-center'>
              <h6 className='bg-blue-500 p-1 text-[12px] min-w-[40%] max-w-[40%] font-[700]'>Phone</h6>
              <h6 className='text-[12px] pl-2'>{messageData?.customerInfo?.campaign_info?.phone}</h6>
            </div>
          </div>
         </div>}
          <div className='mt-2 flex items-center  justify-end'>
              <div className='mr-2'>
              <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={()=>setmodal(false)} />
              </div>
              <ButtonFilledAutoWidth btnName={'Show'}  onClick={()=>{handleModalClickFunc()}} />
          </div>


        </div>

      </Modal>
   
      {!loader ?
      <div className="relative  md:flex md:w-full md:border-box">

          {!disabled_drawer.includes(location.pathname) && !isPublicFeedbackPage && (
          <>
            <div className={`hidden md:block ${step === 1 ? 'min-w-[70px]  w-[70px] max-w-[70px]' : ''} `}>
              {drawer}
            </div>
          </>
         )}

         {!disabled_drawer.includes(location.pathname) && !isPublicFeedbackPage && (
         <div className='flex md:hidden justify-between items-center bg-[#2a297e] text-white py-[15px] px-2'>
          <div onClick={gotodashboard} className='flex items-center'>
            <img  className='w-[30px] h-[30px] object-contain h-8 flex items-center -mt-0.5  hover:opacity-100' src={logo1} />
            <h6 className='ml-5 text-[14px] mt-1 tracking-wider text-[#fff] uppercase font-[800]'>{brandName}</h6>
          </div>
          <HiOutlineMenuAlt4  className='text-[#fff]' size={20} onClick={()=>setdrawer_menu(!drawer_menu)} /> 
         </div>)}

         <Drawer onClose={()=>setdrawer_menu(false)} maskClosable={true} open={drawer_menu} closable={false} className='-p-[5%]' width={'80%'}>
          <div className='bg-[#2a297e] h-[100%] py-[48px]'>
          <IoMdClose onClick={()=>setdrawer_menu(false)} size={20} className='absolute top-[5px] left-[-24px] text-white' />
          <div className='flex items-center  px-[5px]'>
            <img onClick={gotodashboard} className='w-[30px] h-[30px] object-contain h-8 flex items-center -mt-[28px]  hover:opacity-100' src={logo1} />
            <h6 className='ml-5 text-[14px] -mt-4 tracking-wider text-[#fff] uppercase font-[800]'>{brandName}</h6>

          </div>

          <h6 className='p-2 bg-slate-100 text-[12px] opacity-60 mt-2 mb-2'>See the menu option list which was created for you for your sales executive portal for app access!.</h6>

          {/*  */}
           {userRoute?.map((item)=>(

             

            <>
            {(item.roles.length > 0 && item?.roles?.filter((e) => auth?.roles?.includes(e))?.length > 0) ?
             <div className={`flex  px-1 py-2 pl-2 place-items-center  mb-1  cursor-pointer ${path === item?.to?.split('/')[1] ? 'bg-white text-[#1b3f69] opacity-100' : 'text-white opacity-100'}  ${path === item?.to?.split('/')[1] && 'opacity-100'} `} onClick={()=>{setdrawer_menu(false);navigate(item.to);setMobileOpen(false)}}>
                {item.icon && <item.icon size={16}  /> }
                <span className="mt-0 ml-2 text-[12.5px] font-[600]">
                  {item.name} 
                </span>
              </div> 
               : 
              (item.roles.length == 0) && 
              <div className={`flex  px-1 py-2 pl-2 place-items-center  mb-1  cursor-pointer ${path === item?.to?.split('/')[1] ? 'bg-white text-[#1b3f69] opacity-100' : 'text-white opacity-100'}  ${path === item?.to?.split('/')[1] && 'opacity-100'} `} onClick={()=>{setdrawer_menu(false);navigate(item.to);setMobileOpen(false)}}>
                {item.icon && <item.icon size={16}  /> }
                <span className="mt-0 ml-2 text-[12.5px] font-[600]">
                  {item.name} 
                </span>
              </div>} 
            </>
           ))}

            <div className={`flex  absolute bottom-2  px-1 py-1 mx-2 text-black  place-items-center  mb-1 cursor-pointer opacity-50 `} onClick={()=>{setdrawer_menu(false);handleLogout()}}>
             {<HiLogout size={16} className='text-white' /> }
             <span className="mt-1 ml-3 uppercase text-[11.5px] text-white font-[600]">
               Log Out 
             </span>
           </div> 
          </div>
         </Drawer>



  
  
       
  
        {/* <AppBar /> */}
  
       
        {/* <h1 className='ml-20 p-2 bg-slate-400' onClick={()=>toast.success('Hello Im here')}>Amma</h1> */}
  
       
  
        <div className={` bg-gray-0 h-screen relative ${['','/','login','teacher_login','distributor_login']?.includes(path) ? 'md:min-w-[100vw] md:w-[100vw]' :  'md:min-w-[95vw] md:w-[95vw]'} overflow-x-hidden`}>
          <Toaster  position="bottom-center" toastOptions={{
            success: {
              style:{
                background:'black',
                color:'white',
                padding:'4px 7px',
                fontSize:'12px',
                borderRadius:'2px',
                iconTheme: {
                  fontSize:'4px'
                }
              }
            },
            error: {
              style:{
                background:'black',
                color:'white',
                padding:'4px 7px',
                fontSize:'12px',
                borderRadius:'2px',
                iconTheme: {
                  fontSize:'4px'
                }
              }
            }
          }}  />
          <Routes>
            {routes.map((screen,index) => (
              <Route
                key={index}
                exact
                path={screen.path}
                element={screen.private ? <PrivateRoute roles={screen.roles}>{screen.component}</PrivateRoute> : screen.component}
              />
            ))}
            <Route exact path="/distributor_login" element={<DistributorLogin />} />
            <Route exact path="/teacher_login" element={<TeacherLogin />} />
            <Route exact path="/login" element={<Login />} />
          </Routes>
        </div>
      </div>
      :
      <Splash />}

    </div>
  );
}

export default App;
